import classNames from 'classnames';
import { Helmet } from 'react-helmet-async';

import { LayoutContainer } from '@ui/LayoutContainer';
import { BaseLayout } from '@outlet/layouts/BaseLayout';
import { HeaderContainer } from '@outlet/containers/Header';
import { Footer } from '@outlet/components/Footer';

import s from './NavLayout.sss';

type NavLayoutProps = {
  withLayoutContainer?: boolean
  layoutClassName?: string
  className?: string
};

export const NavLayout: React.FC<React.PropsWithChildren<NavLayoutProps>> = ({
  withLayoutContainer = true,
  layoutClassName,
  className,
  children,
}) => (
  <BaseLayout className={classNames(s.root, layoutClassName)}>
    <Helmet>
      <meta name="theme-color" content="#eeeeee" />
    </Helmet>

    {/* Block with 100vh to hide footer */}
    <div className={s.fullHeight}>
      <HeaderContainer />
      {
        withLayoutContainer
          ? (
            <LayoutContainer className={className}>
              {children}
            </LayoutContainer>
          )
          : (
            <div className={className}>
              {children}
            </div>
          )
      }
    </div>

    <Footer />
  </BaseLayout>
);
